var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_142094000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M8031252 -12c-4394069,0 -8031264,3574703 -8031264,7968760 0,4394057 3637195,8031264 8031264,8031264 4394069,0 7968760,-3637195 7968760,-8031264 0,-4394069 -3574703,-7968760 -7968760,-7968760zm0 13656267c-516874,0 -937500,-420626 -937500,-937500 0,-516874 420626,-937500 937500,-937500 516567,0 937500,420626 937500,937500 0,516874 -420945,937500 -937500,937500zm1661564 -5762188c-467504,343429 -724063,1250623 -724063,1703434l0 246248c0,516874 -420945,937500 -937512,937500 -516874,0 -937500,-420626 -937500,-937500l0 -246248c0,-1051560 543130,-2521253 1490942,-3215317 728138,-534685 350008,-1694694 -553429,-1694694 -516874,0 -937500,420626 -937500,937500 0,516886 -420933,937512 -937500,937512 -516874,0 -937500,-420626 -937500,-937512 0,-1550942 1261560,-2812501 2812501,-2812501 1550942,0 2812501,1261560 2812501,2812501 0,892819 -430311,1740946 -1150938,2269076z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelp);
export default __webpack_public_path__ + "static/media/need_help.3399f3f4ae4c9eefe1a4dc6b53f36c24.svg";
export { ForwardRef as ReactComponent };